import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './index.less';

interface BottomNavProps {
  hash?: string;
}

const BottomNav: React.FC<BottomNavProps> = ({ hash }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { id: 'card', label: '卡片信息', path: '/card' },
    { id: 'events', label: '事件大厅', path: '/events' },
    { id: 'achievements', label: '我的成就', path: '/achievements' },
  ];

  const handleNavigate = (path: string) => {
    const url = hash ? `${path}/${hash}` : path;
    navigate(url);
  };

  return (
    <div className="bottom-nav">
      {tabs.map((tab) => (
        <div
          key={tab.id}
          className={`nav-item ${location.pathname.includes(tab.path) ? 'active' : ''}`}
          onClick={() => handleNavigate(tab.path)}
        >
          <span className="nav-label">{tab.label}</span>
        </div>
      ))}
    </div>
  );
};

export default BottomNav; 